module.exports = __webpack_public_path__ + "img/EA210_1-1.786836be.jpg";